module.exports = __webpack_public_path__ + "img/sprite.2bfd9484.png";